class VideoCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", this.toggleVideoPlay.bind(this));
  }

  toggleVideoPlay() {
    const video = this.querySelector("video");
    const iconPlay = this.querySelector(".icon-play");
    const iconStop = this.querySelector(".icon-stop");

    if (video.paused) {
      video.play();
      iconPlay.classList.add("d-none");
      iconStop.classList.remove("d-none");
    } else {
      video.pause();
      iconPlay.classList.remove("d-none");
      iconStop.classList.add("d-none");
    }
  }
}

if (window.customElements.get("video-card") === undefined) {
  customElements.define("video-card", VideoCard);
}
